<template>
  <section class="flex level-1"  :class="{mobile:!mobile}">   

    <!-- //TITLE MOBILE -->
    <div class="mobile"  :class="{isMobile:isMobile}"  v-if="mobile">
      <div class="link">
        <button class="bt btn-back" @click="goBack()">
          <font-awesome-icon :icon="['far', 'angle-left']"/>
        </button>
        <h2>{{general.excursionsTitle}}</h2>
      </div>
      <div class="sep"></div>
    </div>
    <!-- //TITLE MOBILE -->

    <!-- CONTENT-->
    <div class="block__excursion content__excursion" v-if="options.length > 0 || isLoading">

      <!-- //TITLE MOBILE -->
      <div class="header entete mobile">
        <div class="select__wrapper">
          <font-awesome-icon :icon="['far', 'chevron-down']" />

          <b-form-select v-model="selected" :options="options" class="select" @change="changed">
          </b-form-select>

            <div class="target" :class="target" v-if="target=='progress'"> {{general.targetProgress}} </div>
            <div class="target"  :class="target" v-else-if="target=='done'"> {{general.targetDone}} </div>
            <div v-else-if="target == undefined"></div>
        </div>
      </div>
      <!-- //TITLE MOBILE -->

      <!-- PART MIDDLE -->
      <div class="column-middle">

        <div class="header entete desktop">
            <p>{{general.excursionsTitle}}</p>
          
          <div class="select__wrapper">
            <font-awesome-icon :icon="['far', 'chevron-down']" />

            <b-form-select v-model="selected" :options="options" class="select" @change="changed">
            </b-form-select>
              
            <PuSkeleton :loading="isLoading" :count="1" width='40px'>
              <div class="target" style="width: 62px;" :class="target" v-if="target=='progress'">
                  {{general.targetProgress}}                    
              </div>            
              <div class="target" :class="target" v-else-if="target=='done'"> 
                  {{general.targetDone}} 
              </div>
              <div v-else-if="target=='todo' "></div>  
            </PuSkeleton>                
          </div>

        </div>
        
        <div class="sep desktop"></div>

        <section class="block__blog">

          <div class="header">
            <p class="title">
              <PuSkeleton :loading="isLoading" :count="1" width='140px'>              
                {{details.name}}
              </PuSkeleton>
            </p>
            <div class="date">
              <div class="end">
                <font-awesome-icon :icon="['fas', 'calendar-exclamation']"/>
                <span>{{content.dateEnd}}</span>
              </div>
              <span class="separator">|</span>
              <div class="start">
                <PuSkeleton :loading="isLoading" :count="1" width='40px'>
                  {{ details.endDate | moment(true) }}
                </PuSkeleton>
              </div>
            </div>
          </div>

          <PuSkeleton :loading="isLoading" :count="1" width='100%' height="300px">
            <imageLoader
              :img = pictures[0]
              theMinHeight = '300px'
            ></imageLoader>
          </PuSkeleton>

          <PuSkeleton :loading="isLoading" :count="10" width='100%'>
            <div class="content_desc" v-html="details.description">
            </div>
          </PuSkeleton>

        </section>
      </div>
      <!-- PART MIDDLE -->

      <!-- PART RIGHT -->
      <div class="col-right column-right borderLeft">
        <tabsSideBar :selected.sync ="selected" />
      </div>
      <!-- PART RIGHT -->
    </div>

    <div class="block__excursion content__excursion" v-else>
      Aucune excursion renseigné
    </div>
    <!-- CONTENT-->

  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import tabsSideBar from '../../../module/tabs/TabsSidebar'
import ApiService from '../../../../services/ApiService';
import imageLoader from '../../../module/picture/imageLoader'
import ChallengesMixin from '../challenges/ChallengesMixin'

export default {
  name:"challengeExcursions",
    components:{ 
      tabsSideBar,
      imageLoader
    }, 
    mixins: [
      ChallengesMixin      
    ],       
    computed: {
      ...mapGetters([
        'getBlog',
        'getGeneral',
        'getExcursionChallengeSelected',
        'getChallengeSelected',
        'getExcursionChallengeDetail'
      ])
    },
    props:{
      mobile:{
        type:Boolean,
        default:true
      }
    },    
    data () {
      return {
        content:"",
        details:'',
        general:"",
        listAgents:null,
        selected: null,
        target : undefined,
        options: [],
        pictures:[],
      }
    },
    created (){
      this.content = this.getBlog;
      this.general = this.getGeneral;
      this.isLoading = true;
      this.getData().then(() => this.isLoading = false);
    },    
    methods : {   
      async getData(){
        if(this.getChallengeSelected){
          await ApiService.getConcoursApi().getExcursionList(this.getChallengeSelected).then((data) => {
            this.options = data.data;
            this.selected = this.options.length ? this.options[0].value : '';
            this.changed();
          });
        }
      },

      async changed(){
        !this.isLoading ? this.isLoading = true : '';
        await ApiService.getConcoursApi().getExcursionData(this.getChallengeSelected,this.selected).then((data) => {
          this.target = data.data.target;
          this.details = data.data;
          let images = data.data.images;
          images.length ? this.pictures.push(ApiService.getMediaApi().get(images[0].id)): '';
          this.isLoading = false;
        });
      },

      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      },             
    },
    watch : {
      'getChallengeSelected' : function (){
        this.isLoading = true;
        this.getData().then(() => this.isLoading = false);
      },
    },      
};
</script>
